import styled from 'styled-components'

export const TrendingContainer = styled.div`
  background-color: ${props => props.bgColor};
  min-height: 100vh;
  margin-top: 60px;
  margin-bottom: 60px;
  overflow-y: auto;
  transition: background-color 0.3s ease;

  @media screen and (min-width: 768px) {
    margin-left: 250px;
    margin-bottom: 0px;
  }

  &:hover {
    background-color: ${props =>
      props.bgHoverColor ? props.bgHoverColor : props.bgColor};
  }
`

export const TrendingVideoTitle = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
    transform: scale(1.02);
    transition: all 0.3s ease-in-out;
  }
`

export const TitleIconContainer = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 80px;
  margin-left: 10px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease, transform 0.2s ease;

  @media screen and (min-width: 768px) {
    margin-left: 40px;
  }

  &:hover {
    background-color: rgba(150, 150, 150, 0.2);
    transform: rotate(10deg);
  }
`

export const TrendingText = styled.h1`
  font-family: Roboto;
  font-size: 25px;
  color: ${props => props.color};
  transition: color 0.3s ease, transform 0.2s ease;

  @media screen and (min-width: 768px) {
    font-size: 35px;
  }

  &:hover {
    color: ${props => props.hoverColor || '#ff4b4b'};
    transform: scale(1.05);
  }
`

export const TrendingVideoList = styled.ul`
  list-style-type: none;
  display: flex;
  flex-direction: column;
  margin: 0px;
  padding: 0px;

  & > li {
    transition: background-color 0.3s ease, transform 0.2s ease;
    border-radius: 8px;
    padding: 10px;
    margin: 5px 0;

    &:hover {
      background-color: rgba(180, 180, 180, 0.15);
      transform: translateX(5px);
    }
  }
`

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  cursor: progress;
`
